import React, {Suspense} from "react";
import {useSelector} from 'react-redux';
import {useState} from 'react';

//components
import CollapseTab from '../../components/Tabs/CollapseTab';
import StatusIcon from '../../components/Icons/StatusIcon';
import Loading from "../../components/Loading/Loading";

//assets
import icon1 from '../../assets/icons/sections/historial_propietarios.svg';


export default () => {

    const OwnerRecordsContainer = React.lazy(() => import('./components/OwnerRecordsContainer'));
    const [show, setShow] = useState(false);
    let boxData = useSelector(state => state.app.data);
    boxData = boxData && boxData.historialpropietarios;


    return (
        <div onClick={() => setShow(!show)} id="historialpropietarios" className="OwnersRecordsSection">
            {
                boxData && boxData.body && boxData.header && boxData.footer &&
                <CollapseTab
                    sectionName="historialpropietarios"
                    carouselLength={boxData.body && boxData.body.data && Array.isArray(boxData.body.data) ? boxData.body.data.length : 0}
                    icon={icon1}
                    stateIcon={<StatusIcon
                        status={boxData.body && boxData.body.result && boxData.body.result.type}/>}
                    nav={<div
                        className="font-roboto font-bold font-14 txt-blue line-1-2">{boxData.header.title}</div>}>
                    <div onClick={(e) => e.stopPropagation()}>
                        <Suspense fallback={<Loading size='medium'/>}>
                            {show && <OwnerRecordsContainer boxData={boxData}/>}
                        </Suspense>
                    </div>
                </CollapseTab>
            }
        </div>
    )
}
